module.exports = __webpack_public_path__ + "img/9788954431071.2012cab9.jpg";